import { useEffect } from "react";

export default function ProcessmodellModal({ onClose }) {
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === "Escape") {
        onClose();
      }
    };

    document.addEventListener("keydown", handleEscape);

    return () => {
      document.removeEventListener("keydown", handleEscape);
    };
  }, [onClose]);

  return (
    <div
      className="
        fixed inset-0 z-[120]
        flex items-center justify-center
        bg-black/90
        p-4
        backdrop-blur-sm
      "
      onClick={onClose}
    >
      <div
        className="
          relative
          max-h-[95vh]
          w-full
          max-w-[1600px]
          overflow-auto
          rounded-[28px]
          bg-white
          p-4
          shadow-[0_40px_100px_rgba(0,0,0,0.45)]
        "
        onClick={(e) => e.stopPropagation()}
      >
        {/* Stäng */}
        <button
          onClick={onClose}
          className="
            sticky
            top-0
            ml-auto
            flex
            h-12
            w-12
            items-center
            justify-center
            rounded-full
            bg-white
            text-2xl
            shadow-lg
          "
        >
          ×
        </button>

        <img
          src="/Processmodellen.jpg"
          alt="Processmodell"
          className="w-full rounded-2xl"
        />
      </div>
    </div>
  );
}